import { Component } from '@angular/core';

@Component({
  selector: 'cmp-sila-core-header',
  templateUrl: './sila-core-header.component.html',
  styleUrls: ['./sila-core-header.component.scss']
})
export class SilaCoreHeaderComponent {
  public authMode: boolean;

  // constructor(public auth: AuthService) {
  //   this.authMode = AppConfig.get('auth');
  // }
}
